import { messageFactory, Topic } from '../../events';
import { JumpType, FileType } from '../../enums';
import { useSettingsStore } from '../../store';
import { getRequestedContent } from './getRequestedContent';
export const onAVJump = (type, applyJump) => {
    return async () => {
        const { content, type: fileType } = getRequestedContent();
        if (!content || (fileType !== FileType.AUDIO && fileType !== FileType.VIDEO)) {
            return;
        }
        let amount;
        const forward = useSettingsStore.getState().jumpForward;
        const backward = useSettingsStore.getState().jumpBackward;
        if (type === JumpType.FORWARD) {
            amount = forward || 15;
        }
        else {
            amount = backward * -1 || -15;
        }
        const { id } = content;
        const now = (new Date()).toISOString();
        const result = await applyJump(id, fileType, amount);
        if (result === undefined)
            return;
        messageFactory(Topic.PLAYBACK_SEEK, {
            item: {
                type: 'content',
                id,
            },
            start: {
                timestamp: now,
                position: result.start,
            },
            end: {
                timestamp: (new Date()).toISOString(),
                position: result.end,
            },
        });
    };
};
//# sourceMappingURL=onAVJump.js.map